<div class="solid-fallback-background"></div>
<div class="prelogin-background"></div>
<div class="container">
  <div class="prelogin-logo-container">
    <img class="prelogin-logo" src="../../../../assets/hubtiger_logo_full.png" (click)="home()">
  </div>

  <div>
    <div class="hub-content">
      <div class="wizard-register-containers prelogin-container">

        <div class="wizard-free-trial">
          <div class="trial-title">ENABLE TWO-FACTOR AUTHENTICATION FOR YOUR ACCOUNT.</div>
          <div class="trial-blurb">Download the Google Authenticator app from the mobile store and register your
            Hubtiger account for improved security.
          </div>

        </div>

        <div *ngIf="isLoading" class="spinner-container">
          <div class="spinner-border" role="status"></div>
        </div>

        <div class="wizard-inner-container" *ngIf="!isLoading">

          <!-- <div class="row" *ngIf="allowSkip == true">
            <div class="col-md-12">
              <button type="button" class="btn btn-primary skipbtn" (click)="skip()" [disabled]="skipIsBusy">No thanks, skip.</button>
            </div>
          </div> -->

          <div class="row">
            <div class="col-md-12">
              <h2>Step 1</h2>
              <p>Using the Google Authenticator app, you should scan the following QR code:</p>
              <div class="qr-container">
                <img [src]="qrInfo" style="height: 250px; margin-bottom:1rem;"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <p>Alternatively, you may enter the following code to the Google Authenticator app:</p>
              <h3 class="manual-entry-code">{{authenticatorKey}}</h3>
            </div>
          </div>

          <hr style="border-top-color: #fff;">

          <div class="row">
            <div class="col-md-12">
              <h2>Step 2</h2>

              <form [formGroup]="tfaForm" (ngSubmit)="enableTfa(tfaForm.value)">
                <div class="mt-3">
                  <label for="code" class="col-form-label">
                    Enter here the code provided by the Google Authenticator app:
                  </label>
                  <input type="text" id="code" formControlName="code" class="form-control"/>
                  <em *ngIf="validateControl('code') && hasError('code', 'required')">
                    Code is required
                  </em>
                </div>
                <button type="submit" class="btn btn-primary" [disabled]="!tfaForm.valid || isBusy">Enable Two-Factor
                  Authentication
                </button>

                <div *ngIf="showError" class="alert alert-danger" role="alert" style="margin-top:16px;">
                  {{errorMessage}}
                </div>
              </form>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
</div>
<!--<app-help-request></app-help-request>-->
